module.exports = __webpack_public_path__ + "assets/images/project/head/Ryu_Ho-jeong.jpg?v=b358d8ab";